import {
  MutationCache,
  QueryCache,
  QueryClient,
  QueryOptions,
} from '@tanstack/react-query';
import { Cairo, Roboto } from 'next/font/google';
import toast from 'react-hot-toast';

import { Translate } from '@/shared/components/molecules';
import axiosClient, { getErrorCode, getErrorMessage } from '@/shared/lib/axios';
import { errorRespons } from '@/shared/lib/axios/axios';

// new font Optimization feature
export const cairo_font = Cairo({
  subsets: ['arabic'],
  variable: '--font-cairo',
});
export const roboto_font = Roboto({
  subsets: ['latin'],
  style: 'normal',
  variable: '--font-roboto',
  weight: ['400', '500', '700', '900'],
});

const defaultQueryFn = async ({ queryKey }: QueryOptions) => {
  const { data } = await axiosClient.get(`admin${queryKey?.[0]}`);
  return data;
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      queryFn: defaultQueryFn,
    },
  },
  // if there are error code then render it's corresponding translations else show message
  mutationCache: new MutationCache({
    onError: (error) => {
      const errorCode = getErrorCode(error as errorRespons) || '';
      // scape error in settlement because it handled in the component ---- NOTE:need to remove it
      if (!errorCode?.includes('CREATE_SETTLEMENT')) {
        toast.error(
          errorCode ? (
            <Translate namespace='codes' id={errorCode} />
          ) : (
            getErrorMessage(error as errorRespons)
          ),
          {
            id: 'errorID',
          }
        );
      }
      // to log error in sentry
      // if (process.env.NODE_ENV === 'production') Sentry.captureException(error);
    },
    onSuccess: () => {
      // console.log(data);
    },
  }),
  // if there are error code then render it's corresponding translations show message
  queryCache: new QueryCache({
    onError: (error) => {
      const errorCode = getErrorCode(error as errorRespons) || '';
      // scape error in settlement because it handled in the component ---- NOTE:need to remove it
      if (!errorCode?.includes('CREATE_SETTLEMENT')) {
        toast.error(
          errorCode ? (
            <Translate namespace='codes' id={errorCode} />
          ) : (
            getErrorMessage(error as errorRespons)
          ),
          {
            id: 'errorID',
          }
        );
      }
      // to log error in sentry
      // if (process.env.NODE_ENV === 'production') Sentry.captureException(error);
    },
  }),
});
